export var DxpDataLayerEvent;
(function (DxpDataLayerEvent) {
    DxpDataLayerEvent["CONFIGURATOR"] = "Configurator";
})(DxpDataLayerEvent || (DxpDataLayerEvent = {}));
export var DxpDataLayerEventNames;
(function (DxpDataLayerEventNames) {
    DxpDataLayerEventNames["CONFIGURATOR_ENTRY"] = "CNF_EntryPoint";
    DxpDataLayerEventNames["CONFIGURATOR_MODEL"] = "CNF_ModelClicked";
    DxpDataLayerEventNames["CONFIGURATOR_MOTOR"] = "CNF_MotorClicked";
    DxpDataLayerEventNames["CONFIGURATOR_VERSIONS"] = "CNF_VersionsClicked";
    DxpDataLayerEventNames["CONFIGURATOR_EXTERIOR"] = "CNF_ExteriorColorsClicked";
    DxpDataLayerEventNames["CONFIGURATOR_INTERIOR"] = "CNF_InteriorColorsClicked";
    DxpDataLayerEventNames["CONFIGURATOR_ACCESSORIES"] = "CNF_AccessoriesClicked";
    DxpDataLayerEventNames["CONFIGURATOR_CALCULATE_BUTTON"] = "CNF_CalculateButtonClicked";
    DxpDataLayerEventNames["CONFIGURATOR_TEST_DRIVE"] = "CNF_TestDriveClicked";
    DxpDataLayerEventNames["CHECKOUT_LEAD_QUOTE"] = "CNF_LeadQuote";
    DxpDataLayerEventNames["CONFIGURATOR_QUOTE"] = "CNF_QuoteClicked";
    DxpDataLayerEventNames["CNF_DEALERS_CLICKED"] = "CNF_DealersClicked";
})(DxpDataLayerEventNames || (DxpDataLayerEventNames = {}));
export var DataLayerDXPProducts;
(function (DataLayerDXPProducts) {
    DataLayerDXPProducts["FINANCE_CALCULATOR"] = "Finance Calculator";
    DataLayerDXPProducts["CHECKOUT"] = "Checkout";
    DataLayerDXPProducts["ALTSPC"] = "Alt SPC";
})(DataLayerDXPProducts || (DataLayerDXPProducts = {}));
export var DataLayerEvent;
(function (DataLayerEvent) {
    DataLayerEvent["FORM_NAVIGATE"] = "_formNavigate";
    DataLayerEvent["FORM_INTERACT"] = "_formInteract";
})(DataLayerEvent || (DataLayerEvent = {}));
export var DataLayerFormName;
(function (DataLayerFormName) {
    DataLayerFormName["CONFIGURATOR"] = "configurator";
    DataLayerFormName["REPAYMENT_CALCULATOR"] = "repayment calculator";
    DataLayerFormName["FINANCE_APPLICATION"] = "configurator_finance_enquiry";
    DataLayerFormName["CONFIGURATOR_STOCK_RESERVATION"] = "configurator_stock_reservation";
})(DataLayerFormName || (DataLayerFormName = {}));
export var DataLayerFormStage;
(function (DataLayerFormStage) {
    DataLayerFormStage["CATALOG"] = "catalog";
    DataLayerFormStage["CONTINUE_CHECKOUT"] = "continue";
    DataLayerFormStage["CONFIGURE_CAR"] = "configure your car";
    DataLayerFormStage["VARIANT_CONFIGURATOR"] = "variant";
    DataLayerFormStage["PAYMENT_DISPLAY"] = "payment method displayed";
    DataLayerFormStage["CHECKOUT"] = "checkout";
    DataLayerFormStage["START"] = "start";
    DataLayerFormStage["FA_START"] = "start";
    DataLayerFormStage["FA_SUBMITTED"] = "submitted";
    DataLayerFormStage["CHECKOUT_CONFIRMATION"] = "enquire submitted";
    DataLayerFormStage["DEALER"] = "enquire select retailer";
    DataLayerFormStage["SELECT_DEALER"] = "select dealer";
    DataLayerFormStage["ENQUIRY_FORM"] = "enquire customer information";
    DataLayerFormStage["CUSTOMER_INFORMATION"] = "customer information";
    DataLayerFormStage["PAYMENT_METHOD"] = "payment_method";
    DataLayerFormStage["EMAIL_MY_CONFIGURATION_SUBMITTED"] = "email my configuration submitted";
    DataLayerFormStage["FINALISE_TRANSACTION"] = "finalise transaction";
})(DataLayerFormStage || (DataLayerFormStage = {}));
export var DesignType;
(function (DesignType) {
    DesignType["INTERIOR"] = "subaru_interior";
    DesignType["SUBARU_EXTERIOR"] = "subaru_colour";
})(DesignType || (DesignType = {}));
export var FormFieldName;
(function (FormFieldName) {
    FormFieldName["COLOR"] = "colour";
    FormFieldName["SPECKPACK"] = "specPack";
    FormFieldName["LOANTERM"] = "loan term";
})(FormFieldName || (FormFieldName = {}));
//# sourceMappingURL=customDataLayerTypes.js.map